﻿[
  {
    "draftJersey": "001",
    "name": "Ainara Navas",
    "age": 24,
    "foot": "right",
    "height": 162,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/001.jpg",
    "macros": {
      "reflexes": 82,
      "handling": 82,
      "kicking": 78,
      "diving": 80
    },
    "profileYtVideoId": "e3CW8-j76h4",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "003",
    "name": "Ainoa Díaz",
    "age": 22,
    "foot": "left",
    "height": 167,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/003.jpg",
    "macros": {
      "reflexes": 90,
      "handling": 87,
      "kicking": 81,
      "diving": 87
    },
    "profileYtVideoId": "eyXY1ys5q-w",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "004",
    "name": "Anna Tan",
    "age": 19,
    "foot": "right",
    "height": 165,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/004.jpg",
    "macros": {
      "reflexes": 83,
      "handling": 79,
      "kicking": 75,
      "diving": 82
    },
    "profileYtVideoId": "jKv4omKRbSA",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "006",
    "name": "Andrea Amil",
    "age": 24,
    "foot": "left",
    "height": 173,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/006.jpg",
    "macros": {
      "reflexes": 85,
      "handling": 90,
      "kicking": 80,
      "diving": 85
    },
    "profileYtVideoId": "StZg_J6pSUg",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "007",
    "name": "Roberta Ana Archibald",
    "age": 31,
    "foot": "right",
    "height": 170,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/007.jpg",
    "macros": {
      "reflexes": 86,
      "handling": 84,
      "kicking": 86,
      "diving": 83
    },
    "profileYtVideoId": "k838wXMP1Gg",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "009",
    "name": "Andrea Santaularia",
    "age": 21,
    "foot": "right",
    "height": 163,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/009.jpg",
    "macros": {
      "reflexes": 92,
      "handling": 85,
      "kicking": 91,
      "diving": 86
    },
    "profileYtVideoId": "AYUjxJ5VfcQ",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "010",
    "name": "Aitana Carruana",
    "age": 22,
    "foot": "right",
    "height": 162,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/010.jpg",
    "macros": {
      "reflexes": 78,
      "handling": 73,
      "kicking": 72,
      "diving": 78
    },
    "profileYtVideoId": "bD23DHRaBsY",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": "011",
    "name": "Andrea Uceda",
    "age": 21,
    "foot": "right",
    "height": 168,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/011.jpg",
    "macros": {
      "reflexes": 88,
      "handling": 79,
      "kicking": 86,
      "diving": 91
    },
    "profileYtVideoId": "1VxxDKAOuMw",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": "012",
    "name": "Anna Armengol",
    "age": 23,
    "foot": "right",
    "height": 160,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/012.jpg",
    "macros": {
      "reflexes": 95,
      "handling": 88,
      "kicking": 91,
      "diving": 95
    },
    "profileYtVideoId": "hEgQD-D69PM",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "013",
    "name": "Aitana Saucedo",
    "age": 17,
    "foot": "right",
    "height": 167,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/013.jpg",
    "macros": {
      "reflexes": 74,
      "handling": 79,
      "kicking": 79,
      "diving": 86
    },
    "profileYtVideoId": "wrcLhmk0qmU",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": "014",
    "name": "Judit Fabregat",
    "age": 17,
    "foot": "right",
    "height": 176,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/014.jpg",
    "macros": {
      "reflexes": 84,
      "handling": 74,
      "kicking": 77,
      "diving": 83
    },
    "profileYtVideoId": "SFpx4gcfbYA",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": "015",
    "name": "Ariadna Sáez",
    "age": 25,
    "foot": "right",
    "height": 169,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/015.jpg",
    "macros": {
      "reflexes": 89,
      "handling": 83,
      "kicking": 95,
      "diving": 95
    },
    "profileYtVideoId": "kbL2iY8XGJ8",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": "017",
    "name": "Chiara Povedano",
    "age": 19,
    "foot": "right",
    "height": 175,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/017.jpg",
    "macros": {
      "reflexes": 79,
      "handling": 76,
      "kicking": 76,
      "diving": 82
    },
    "profileYtVideoId": "0A40AZnNMdo",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": "018",
    "name": "Érica Ruiz",
    "age": 21,
    "foot": "right",
    "height": 168,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/018.jpg",
    "macros": {
      "reflexes": 87,
      "handling": 84,
      "kicking": 86,
      "diving": 90
    },
    "profileYtVideoId": "VKiwMwnIoyw",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": "019",
    "name": "Ingrid Cruz",
    "age": 22,
    "foot": "right",
    "height": 162,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/019.jpg",
    "macros": {
      "reflexes": 81,
      "handling": 84,
      "kicking": 83,
      "diving": 78
    },
    "profileYtVideoId": "IvGNMMy788g",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": "020",
    "name": "Eva López",
    "age": 24,
    "foot": "right",
    "height": 169,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/020.jpg",
    "macros": {
      "reflexes": 84,
      "handling": 94,
      "kicking": 89,
      "diving": 88
    },
    "profileYtVideoId": "MaMEBzxSz1A",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": "021",
    "name": "Mireia Nagel",
    "age": 28,
    "foot": "right",
    "height": 163,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/021.jpg",
    "macros": {
      "reflexes": 85,
      "handling": 89,
      "kicking": 81,
      "diving": 84
    },
    "profileYtVideoId": "oX2P6beJRn8",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": "022",
    "name": "Blanca del Valle",
    "age": 18,
    "foot": "right",
    "height": 161,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/022.jpg",
    "macros": {
      "reflexes": 74,
      "handling": 84,
      "kicking": 79,
      "diving": 75
    },
    "profileYtVideoId": "3lMk84TMaWU",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": "023",
    "name": "Irene Melero",
    "age": 20,
    "foot": "right",
    "height": 156,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/023.jpg",
    "macros": {
      "reflexes": 82,
      "handling": 80,
      "kicking": 76,
      "diving": 85
    },
    "profileYtVideoId": "nSshyt_HZKs",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": "024",
    "name": "Jone Guarrotxena",
    "age": 30,
    "foot": "right",
    "height": 170,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/024.jpg",
    "macros": {
      "reflexes": 75,
      "handling": 78,
      "kicking": 81,
      "diving": 84
    },
    "profileYtVideoId": "2T0gxWnsiIo",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": "025",
    "name": "Judith Jones",
    "age": 22,
    "foot": "right",
    "height": 163,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/025.jpg",
    "macros": {
      "reflexes": 83,
      "handling": 86,
      "kicking": 86,
      "diving": 86
    },
    "profileYtVideoId": "X4QpyifdMdI",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": "026",
    "name": "Julia Font",
    "age": 21,
    "foot": "right",
    "height": 174,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/026.jpg",
    "macros": {
      "reflexes": 80,
      "handling": 79,
      "kicking": 80,
      "diving": 82
    },
    "profileYtVideoId": "tUnBqJElcOA",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": "028",
    "name": "Laura Oliva",
    "age": 34,
    "foot": "right",
    "height": 170,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/028.jpg",
    "macros": {
      "reflexes": 74,
      "handling": 81,
      "kicking": 77,
      "diving": 79
    },
    "profileYtVideoId": "5m0CjyjUq5s",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": "029",
    "name": "Laura Vilaseca",
    "age": 23,
    "foot": "right",
    "height": 173,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/029.jpg",
    "macros": {
      "reflexes": 91,
      "handling": 95,
      "kicking": 90,
      "diving": 88
    },
    "profileYtVideoId": "47iLnDtz4J4",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": "030",
    "name": "Mar Vázquez",
    "age": 27,
    "foot": "right",
    "height": 155,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/030.jpg",
    "macros": {
      "reflexes": 86,
      "handling": 83,
      "kicking": 91,
      "diving": 89
    },
    "profileYtVideoId": "eiLOc6YiSwc",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": "031",
    "name": "Marina Barneda",
    "age": 25,
    "foot": "left",
    "height": 160,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/031.jpg",
    "macros": {
      "reflexes": 89,
      "handling": 84,
      "kicking": 84,
      "diving": 83
    },
    "profileYtVideoId": "UTMiKnubHlI",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": "032",
    "name": "Marta Roldán",
    "age": 20,
    "foot": "right",
    "height": 158,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/032.jpg",
    "macros": {
      "reflexes": 90,
      "handling": 83,
      "kicking": 86,
      "diving": 85
    },
    "profileYtVideoId": "GMNrKuNx3ok",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": "033",
    "name": "Mónica Utrilla",
    "age": 28,
    "foot": "right",
    "height": 169,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/033.jpg",
    "macros": {
      "reflexes": 79,
      "handling": 83,
      "kicking": 76,
      "diving": 84
    },
    "profileYtVideoId": "tad6Hsdqgk4",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": "034",
    "name": "Naiara Zárate",
    "age": 29,
    "foot": "right",
    "height": 160,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/034.jpg",
    "macros": {
      "reflexes": 76,
      "handling": 80,
      "kicking": 82,
      "diving": 79
    },
    "profileYtVideoId": "oDN736lkXbA",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": "035",
    "name": "Natividad Flores",
    "age": 25,
    "foot": "right",
    "height": 160,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/035.jpg",
    "macros": {
      "reflexes": 86,
      "handling": 87,
      "kicking": 87,
      "diving": 88
    },
    "profileYtVideoId": "Odcuw1WJWG8",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": "036",
    "name": "Nerea Bermudo",
    "age": 17,
    "foot": "right",
    "height": 170,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/036.jpg",
    "macros": {
      "reflexes": 91,
      "handling": 92,
      "kicking": 87,
      "diving": 87
    },
    "profileYtVideoId": "em66cTftB_U",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": "037",
    "name": "Nuri Garcia",
    "age": 22,
    "foot": "right",
    "height": 164,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/037.jpg",
    "macros": {
      "reflexes": 75,
      "handling": 83,
      "kicking": 87,
      "diving": 88
    },
    "profileYtVideoId": "PQaMami-ES8",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": "038",
    "name": "Núria González",
    "age": 21,
    "foot": "left",
    "height": 165,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/038.jpg",
    "macros": {
      "reflexes": 94,
      "handling": 90,
      "kicking": 90,
      "diving": 83
    },
    "profileYtVideoId": "V88MDuUb5fY",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": "039",
    "name": "Fàtima Fabra",
    "age": 29,
    "foot": "right",
    "height": 165,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/039.jpg",
    "macros": {
      "reflexes": 86,
      "handling": 90,
      "kicking": 87,
      "diving": 88
    },
    "profileYtVideoId": "0PHLDgSHeBE",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": "040",
    "name": "Paula Poch",
    "age": 20,
    "foot": "right",
    "height": 170,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/040.jpg",
    "macros": {
      "reflexes": 85,
      "handling": 79,
      "kicking": 75,
      "diving": 91
    },
    "profileYtVideoId": "lm92tHNY69o",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": "041",
    "name": "Yanira Ortigosa",
    "age": 25,
    "foot": "right",
    "height": 168,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/041.jpg",
    "macros": {
      "reflexes": 79,
      "handling": 81,
      "kicking": 79,
      "diving": 78
    },
    "profileYtVideoId": "TuJtSCRQZ4Y",
    "matchYtVideoId": "vIs_3tlSW90"
  }
]
